/*
 *   File : header.js
 *   Author : https://evoqins.com
 *   Description : Header component
 *   Integrations : js-cookie,react-toastify
 *   Version : 1.0.0
*/

import React, { useState } from 'react';

// Custom component
import OverLay from '../Others/overlay';
import LeftNavigationWidget from './sidebar';
import { removeAccessToken } from '../../Helper/cookie';


const CustomHeader = (props) => {

    const [toggleMore, setToggleMore] = useState(false);

    // handle logout — remove cookie with same path/domain as login
    const _handleLogout = () => {
        removeAccessToken();
        window.location.replace("/");
    };

    // handle close offcanvas 
    const _handleCloseOffcanvas = () => {
        var button = document.getElementById("offcanvas-close");
        button.click();
    };

    return (
        <div className={`e-header`}>
            <div className='d-flex justify-content-space-between '>
                <div className='ps-3 '>
                    <img src={require("../../Assets/Images/Header/hamburger.svg").default}
                        // width={"24px"}
                        // height={"24px"}
                        alt='Hamburger icon'
                        className='cursor-pointer d-xl-block d-lg-block d-md-none d-none'
                        onClick={props.handleToggle} />

                    <img src={require("../../Assets/Images/Header/hamburger.svg").default}
                        // width={"24px"}
                        // height={"24px"}
                        alt='Hamburger icon'
                        className='cursor-pointer d-xl-none d-lg-none d-md-block d-block'
                        data-bs-toggle="offcanvas"
                        data-bs-target="#left-navigation-offcanvas" />

                    {/* <img src={require("../../Assets/Images/Header/hamburger.svg").default}
                        draggable={false}
                        className='cursor-pointer'
                        alt='ham-burger'
                        // onClick={props.handleToggle} 
                        data-bs-toggle="offcanvas"
                        data-bs-target="#left-navigation-offcanvas" /> */}
                </div>

                {/* offcanvas */}
                <div className="offcanvas offcanvas-start w-auto" data-bs-backdrop="static" data-bs-scroll="false"
                    tabIndex="-1"
                    id="left-navigation-offcanvas"
                    aria-labelledby="offcanvasWithBothOptionsLabel">
                    <div className="overflow-auto e-offcanvas-wrapper">
                        <div className="text-end pe-3">
                            <button id="offcanvas-close"
                                type="button"
                                className="btn-close mt-2 d-none"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"></button>
                        </div>
                        <LeftNavigationWidget type="offcanvas"
                            token={props.token}
                            handleCloseOffCanvas={_handleCloseOffcanvas}
                        />
                    </div>
                </div>

                <div className='d-flex justify-content-end pe-4 align-items-center'>

                    <div className='e-dropdown-more-wrapper position-relative'>
                        <img draggable={false} src={require('../../Assets/Images/Header/profile.svg').default}
                            width={64}
                            className="cursor-pointer"
                            alt='Profile icon'
                            onClick={() => setToggleMore(!toggleMore)} />

                        {toggleMore &&
                            <>
                                <OverLay isOpen={toggleMore} onClose={() => setToggleMore(!toggleMore)} />
                                <div className="e-dropdown-more e-bg-white text-start right-neg-14px z-index-99"
                                    onClick={() => setToggleMore(!toggleMore)}>

                                    <p className='mb-0 e-text-rich-black e-primary-font e-font-12 e-font-weight-400 line-height-16px cursor-pointer text-decoration-hover-underline'
                                        onClick={_handleLogout} >
                                        Logout
                                    </p>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>

        </div>
    )
}

export default CustomHeader;